import { TApiResponse } from '@/common/types/response';

import { calculateDynamic, setDashboardsLocalStorage } from '../../utils/localStorage';
import { TDashboardStoreState } from './types';

export function setRegionStatistic(
  state: TDashboardStoreState,
  res: TApiResponse<TDashboardStoreState['regionStatistic']>,
) {
  state.regionStatistic = res.data;
  setDashboardsLocalStorage({
    data: calculateDynamic(res.data, 'amount', 'oldAmount'),
    keyData: 'regionStatistic',
  });
}

export function setTopCountryPartners(
  state: TDashboardStoreState,
  res: TApiResponse<TDashboardStoreState['topCountryPartners']>,
) {
  state.topCountryPartners = res.data;
  setDashboardsLocalStorage({
    data: res.data,
    keyData: 'topCountryPartners',
  });
}

export function setTopEffectiveRegions(
  state: TDashboardStoreState,
  res: TApiResponse<TDashboardStoreState['topEffectiveRegions']>,
) {
  state.topEffectiveRegions = res.data;
}

export function setTopEffectiveRegionsRating(
  state: TDashboardStoreState,
  res: TApiResponse<TDashboardStoreState['topEffectiveRegionsRating']>,
) {
  state.topEffectiveRegionsRating = res.data;
  setDashboardsLocalStorage({
    data: calculateDynamic(res.data, 'value', 'oldValue'),
    keyData: 'topEffectiveRegionsRating',
  });
}

export function setEventsCountByTypes(
  state: TDashboardStoreState,
  res: TApiResponse<TDashboardStoreState['eventsCountByTypes']>,
) {
  state.eventsCountByTypes = res.data;
}

export function setAgreementsCountByTypes(
  state: TDashboardStoreState,
  res: TApiResponse<TDashboardStoreState['agreementsCountByTypes']>,
) {
  state.agreementsCountByTypes = res.data;
}

export function setEventTypes(state: TDashboardStoreState, res: TApiResponse<TDashboardStoreState['eventTypes']>) {
  state.eventTypes = res.data;
}

export function setEventVedTypes(state: TDashboardStoreState, res: TApiResponse<TDashboardStoreState['eventVedTypes']>) {
  state.eventVedTypes = res.data;
}

export function setEventStatuses(
  state: TDashboardStoreState,
  res: TApiResponse<TDashboardStoreState['eventStatuses']>,
) {
  state.eventStatuses = res.data;
}

export function setPlannedEvents(
  state: TDashboardStoreState,
  res: TApiResponse<TDashboardStoreState['plannedEvents']>,
) {
  state.plannedEvents = res.data;
}
